import { createContext } from 'react'
import { FormContextType } from './types'

export const FormContext = createContext<FormContextType<{ [key: string]: any }>>({
  formData: {},
  setFormData: () => {},
  errors: {},
  setErrors: () => {},
  hasErrors: () => false
})
